import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavPanelGroup from 'components/molecules/NavV2/NavPanelGroup';
// import NavPanelFooter from 'components/molecules/NavV2/NavPanelFooter';
import useAccessibleNavScreens, { NavScreenGroup, NavScreenOption } from 'hooks/nav/useAccessibleNavScreens';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_NAV_GROUP_EXPAND, GLOBAL_NAV_NAVIGATION } from 'utils/mixpanelEventNames';
import { POWERED_BY_FOOTER_HEIGHT_PX } from 'config/constants';

interface Props {
    activeItemId?: string;
}

// 220px navigation panel. Shares its slot with FilterV2 — MainContainer guarantees only one
// of the two is open — so it matches the filter's 500ms width transition.
function NavPanel({ activeItemId }: Props) {
    const navigate = useNavigate();
    const navScreens = useAccessibleNavScreens();

    // Selecting a route leaves the panel open, so the new active item stays visible
    const handleSelect = (group: NavScreenGroup, url: string, item: NavScreenOption) => {
        navigate(url);
        trackEventMixpanel(GLOBAL_NAV_NAVIGATION, { screen: item?.label, screenHeader: group?.label, url });
    };

    const handleToggle = (group: NavScreenGroup, expanded: boolean) => {
        trackEventMixpanel(GLOBAL_NAV_GROUP_EXPAND, { group: group?.label, expanded });
    };

    return (
        <div
            className="global-filter-v2-width fixed z-[51] flex flex-col overflow-hidden border-r border-filterV2Border bg-white"
            style={{
                top: 'var(--navbar-v2-height)',
                bottom: POWERED_BY_FOOTER_HEIGHT_PX,
                left: 'var(--nav-rail-width)',
                transition: 'width 500ms ease',
            }}
        >
            <div className="flex-1 space-y-5 overflow-y-auto py-4">
                {navScreens.map((group) => (
                    <NavPanelGroup
                        key={group.label}
                        group={group}
                        activeItemId={activeItemId}
                        onSelect={handleSelect}
                        onToggle={handleToggle}
                    />
                ))}
            </div>
            {/* <NavPanelFooter /> */}
        </div>
    );
}

export default NavPanel;
